module.exports = __webpack_public_path__ + "img/video-icon.2992e127.svg";